import { useSearchParams } from "react-router-dom";
import { PublishedForms } from "src/containers";
import { FormCategoriesList } from "src/features/observations/containers/FormCategoriesList";
import { usePublishedFormsCategories } from "src/hooks/usePublishedFormsCategories";

const Reports = () => {
	const [searchParams] = useSearchParams();
	const { data: categories, isLoading: isCategoriesLoading } =
		usePublishedFormsCategories();

	const category = searchParams.get("category") || "";

	return (
		<div aria-label="All published forms">
			{category && (
				<PublishedForms
					formsRedirectBaseUrl="/observations/reports/form/"
					category={category}
				/>
			)}

			{!category && (
				<div>
					<h2 className="font-heading text-lg font-medium text-foreground mb-6">
						Categories
					</h2>

					{isCategoriesLoading ? (
						<div className="flex justify-center py-12">
							<div className="w-5 h-5 border-2 border-border border-t-primary rounded-full animate-spin" />
						</div>
					) : (
						<FormCategoriesList
							categories={categories}
							admin={false}
							itemHref={(category) =>
								`/observations/reports/?category=${category.name}`
							}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default Reports;
